import React from 'react';

const Link = ({ dataTag, url, classes, text, OpenInNewWindow = false }) => {
	if (!url) {
		return null;
	}

	const openTextLinkInNewTab = (e) => {
		if (OpenInNewWindow) {
			e.preventDefault();
			window.open(url);
		}
	};

	return (
		<a
			data-tag-name={dataTag}
			href={url}
			className={classes}
			onClick={openTextLinkInNewTab}>
			{text}
		</a>
	);
};

export default Link;
